import { render, staticRenderFns } from "./checkDialog.vue?vue&type=template&id=3fd84fe2&scoped=true"
import script from "./checkDialog.vue?vue&type=script&lang=js"
export * from "./checkDialog.vue?vue&type=script&lang=js"
import style0 from "./checkDialog.vue?vue&type=style&index=0&id=3fd84fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd84fe2",
  null
  
)

export default component.exports